<div class="dashboard-transport-registration-smartphone-connection">

  <div class="vertical-layout">
    <div class="form" [formGroup]="detailsFormGroup">
      <mat-radio-group class="messagingoptions" formControlName="driverCommunicationOption"
        aria-label="Choose driver communication option">
        @for (option of communicationOptions; track option) {
          @if (option === 'loaner') {
            <div>
              <mat-radio-button class="radio-btn" value={{terminalContextConstants.DRIVER_COMMUNICATION_LOANER}}>
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.loaner"></sc-dictionary-label>
              </mat-radio-button>
              <div class="option-hint">
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.loaner.hint"></sc-dictionary-label>
              </div>
            </div>
          }
          @if (option === 'phone-call') {
            <div>
              <mat-radio-button class="radio-btn" value="phone-call">
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-call"></sc-dictionary-label>
              </mat-radio-button>
              <div class="option-hint">
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-call.hint"></sc-dictionary-label>
              </div>
            </div>
          }
          @if (option === 'sms') {
            <div>
              <mat-radio-button class="radio-btn" value="sms">
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.sms"></sc-dictionary-label>
              </mat-radio-button>
              <div class="option-hint">
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.sms.hint"></sc-dictionary-label>
              </div>
            </div>
          }
          @if (option === 'global-connect') {
            <div>
              <mat-radio-button class="radio-btn" value={{terminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE}}>
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.own-smartphone"></sc-dictionary-label>
              </mat-radio-button>
              <div class="option-hint">
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.own-smartphone.hint"></sc-dictionary-label>
              </div>
            </div>
          }
          @if (option === 'messaging-hint') {
            <div>
              <div>
                <sc-dictionary-label
                dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.messaging-hint"></sc-dictionary-label>
              </div>
            </div>
          }
        }
      </mat-radio-group>
      <div>
        <sc-dictionary-label
        dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.description"></sc-dictionary-label>
      </div>
    </div>
    <div class="vertical-spacer"></div>
    @if (showGcAppInfo) {
      <div class="title">
        <sc-dictionary-label
        dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.global-connect-app.headline"></sc-dictionary-label>
      </div>
      <div class="spacer"></div>
      @if (qrCodeUrl) {
        <qrcode [qrdata]="qrCodeUrl" [scale]="6"></qrcode>
      }
      <div class="app-store-headline">
        <h3>
          <sc-dictionary-label
          dictionaryKey="tmc-yard.registration-terminal.ui.transport-registration-smartphone-connection.global-connect-app.app-store-headline"></sc-dictionary-label>
        </h3>
      </div>
      <div class="app-store-hint">
        <sc-dictionary-label
        dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.global-connect-app.app-store-hint"></sc-dictionary-label>
      </div>
      <div class="grid">
        <div class="app-store-button">
          <img (click)="openAppOverlay('apple-app-store', appleAppStoreUrl, 'svg')"
            src="/assets/default/icons/app-store/apple-app-store-badge-{{translationService.language}}.svg"
            class="app-badge-apple apple-app-store-badge" alt="" />
          </div>
          <div class="spacer"></div>
          <div class="google-play-button">
            <img (click)="openAppOverlay('google-play-store', googlePlayStoreUrl, 'png')"
              src="/assets/default/icons/app-store/google-play-store-badge-{{translationService.language}}.png"
              class="app-badge-google google-play-store-badge" alt="" />
            </div>
          </div>
        }
        @if (phoneNumberRequired && !hidePhoneNumberInput) {
          <form [formGroup]="phoneNumberFormGroup">
            @if (!showPhoneNumberDialog) {
              <sc-phone-number-field formControlName="phoneNumber" class="phone-number"
              [required]="true" [showOthersOption]="true" [limitCountries]="phonenumberAllowedCountries" labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-number.label"></sc-phone-number-field>
            }
            @if (showPhoneNumberDialog) {
              <sc-phone-number-dialog-field formControlName="phoneNumber" class="phone-number"
          [required]="true" [showOthersOption]="true" [limitCountries]="phonenumberAllowedCountries" [label]="'Phone Number' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-number.label',
                translationService.language]"></sc-phone-number-dialog-field>
            }
          </form>
          <div class="info">
            <sc-dictionary-label
            dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.used-phone-number"></sc-dictionary-label>
            {{phoneNumberFormGroup.value.phoneNumber}}
          </div>
          @if (!phoneNumberValid) {
            <div class="error">
              <sc-dictionary-label
              dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.invalid-phone-number"></sc-dictionary-label>
            </div>
          }
          @if (phoneNumberValid) {
            <div>&nbsp;</div>
          }
          @if (showHints) {
<div class="title" [innerHTML]="'#undefined' | translate:
                ['tmc-yard.entity.transport.phone-hint', translationService.language] | trustHtml"></div>
          }
        }
        <div class="vertical-spacer"></div>
      </div>

    </div>
